const e = {
  "roche-quote": "roche-quote",
  "roche-quote__image": "roche-quote__image",
  "roche-quote__content": "roche-quote__content",
  "roche-quote__text": "roche-quote__text",
  "roche-quote__text--small": "roche-quote__text--small",
  "roche-quote__subline": "roche-quote__subline",
  "roche-quote__link": "roche-quote__link",
  "roche-quote--with-image": "roche-quote--with-image",
  "roche-quote--equal-ratio": "roche-quote--equal-ratio"
};
export {
  e as default
};
